import React, { memo, useState, useEffect, useRef, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { Grid, Drawer, useTheme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import useViewportSize from '~/components/useViewportSize'
import ProductDetails from './ProductDetails/ProductDetails'

import track from '~/track'
import actions from '~/actions'

const useStyles = makeStyles(() => ({
  drawerMobile: {
    width: '100%',
    overflow: 'hidden',
    flexShrink: 0,
  },
  drawerDesktop: {
    width: 700,
    overflow: 'hidden',
    flexShrink: 0,
  },
}))

export const useDrawerProduct = () => {
  const [drawerProduct, setDrawerProduct] = useState(null)
  const closeDrawerProduct = useCallback(() => setDrawerProduct(null))

  return {
    drawerProduct,
    setDrawerProduct,
    closeDrawerProduct,
  }
}

function DrawerProduct({ data, onClose, onFind, position, store, noRedirect, config }) {
  const history = useHistory()

  const ref = useRef(null)
  const timeoutRef = useRef(null)

  const [copy, setCopy] = useState(null)
  const [open, setOpen] = useState(false)

  // const { drawerProduct,  }

  const theme = useTheme()
  const classes = useStyles()
  const dispatch = useDispatch()
  const viewport = useViewportSize()
  const isMobile = viewport.width < theme.gofind.desktopMaxWidth

  const handleClose = useCallback(() => {
    dispatch(actions.dialog.error(false))
    setOpen(false)

    onClose && onClose()

    !noRedirect && history.location.state?.fromApp ? history.goBack() : history.push('/')
  })

  const handleFind = useCallback(() => {
    dispatch(actions.dialog.error(false))
    setOpen(false)

    onFind && onFind()

    track('encontrarLojaFisica', {
      category: 'produto',
      name: data.product.description,
    })

    setTimeout(() => {
      history.replace(`/produto/${data.product.gtin}`)
    }, 300)
  }, [data])

  useEffect(() => {
    setOpen(Boolean(data))

    if (data && !ref.current) setCopy(data)

    if (!data && ref.current) {
      timeoutRef.current = setTimeout(() => {
        setCopy(null)
      }, [300])
    }

    if (data?.product?.gtin !== ref.current) {
      clearTimeout(timeoutRef.current)
      setCopy(data)
    }

    ref.current = data?.product?.gtin
  }, [data])

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      classes={{ paper: isMobile ? classes.drawerMobile : classes.drawerDesktop }}
      PaperProps={{ 'data-cy': 'drawer-product-details' }}
    >
      {copy ? (
        <ProductDetails
          data={copy}
          onClose={handleClose}
          onFind={handleFind}
          store={store}
          position={position}
          config={config}
        />
      ) : (
        <Grid />
      )}
    </Drawer>
  )
}

export default memo(DrawerProduct)
